import { jsxs as Ae, jsx as x, Fragment as Dn } from "react/jsx-runtime";
import * as f from "react";
import { forwardRef as Nt, useLayoutEffect as Ln, useEffect as Mn, useState as $n, Children as kn } from "react";
import * as Dt from "react-dom";
import Fn from "react-dom";
const In = {
  LG: "lg"
};
function Bn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ct = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var lt;
function Wn() {
  return lt || (lt = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var r = "", s = 0; s < arguments.length; s++) {
          var a = arguments[s];
          a && (r = i(r, o(a)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var s = "";
        for (var a in r)
          t.call(r, a) && r[a] && (s = i(s, a));
        return s;
      }
      function i(r, s) {
        return s ? r ? r + " " + s : r + s : r;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(ct)), ct.exports;
}
var Hn = Wn();
const ut = /* @__PURE__ */ Bn(Hn), jn = "_rotate_1xozj_1", zn = "_dash_1xozj_1", ue = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: jn,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: zn,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, fe = "purpur-spinner", qn = {
  SM: "sm"
}, Vn = ({
  ["data-testid"]: e,
  disabled: t = !1,
  negative: n = !1,
  size: o = qn.SM,
  ...i
}) => /* @__PURE__ */ x(
  "div",
  {
    className: ut([ue[fe], ue[`${fe}--${o}`]]),
    "data-testid": e,
    ...i,
    children: /* @__PURE__ */ x("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ x(
      "circle",
      {
        className: ut(ue[`${fe}__circle`], {
          [ue[`${fe}__circle--disabled`]]: t,
          [ue[`${fe}__circle--negative`]]: n
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function Un(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ft = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var pt;
function Yn() {
  return pt || (pt = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var r = "", s = 0; s < arguments.length; s++) {
          var a = arguments[s];
          a && (r = i(r, o.call(this, a)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var s = "";
        for (var a in r)
          t.call(r, a) && r[a] && (s = i(s, this && this[a] || a));
        return s;
      }
      function i(r, s) {
        return s ? r ? r + " " + s : r + s : r;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(ft)), ft.exports;
}
var Gn = Yn();
const Xn = /* @__PURE__ */ Un(Gn), Zn = {
  "purpur-button": "_purpur-button_w455q_1",
  "purpur-button--xs": "_purpur-button--xs_w455q_33",
  "purpur-button--icon-only": "_purpur-button--icon-only_w455q_36",
  "purpur-button--sm": "_purpur-button--sm_w455q_39",
  "purpur-button--md": "_purpur-button--md_w455q_45",
  "purpur-button--lg": "_purpur-button--lg_w455q_51",
  "purpur-button--full-width": "_purpur-button--full-width_w455q_57",
  "purpur-button--primary": "_purpur-button--primary_w455q_60",
  "purpur-button--disabled": "_purpur-button--disabled_w455q_64",
  "purpur-button--primary-negative": "_purpur-button--primary-negative_w455q_70",
  "purpur-button--secondary": "_purpur-button--secondary_w455q_82",
  "purpur-button--secondary-negative": "_purpur-button--secondary-negative_w455q_93",
  "purpur-button--expressive": "_purpur-button--expressive_w455q_104",
  "purpur-button--expressive-negative": "_purpur-button--expressive-negative_w455q_114",
  "purpur-button--negative": "_purpur-button--negative_w455q_126",
  "purpur-button--destructive": "_purpur-button--destructive_w455q_133",
  "purpur-button--destructive-negative": "_purpur-button--destructive-negative_w455q_143",
  "purpur-button--tertiary-purple": "_purpur-button--tertiary-purple_w455q_153",
  "purpur-button--tertiary-purple-negative": "_purpur-button--tertiary-purple-negative_w455q_166",
  "purpur-button--text-negative": "_purpur-button--text-negative_w455q_181",
  "purpur-button--text": "_purpur-button--text_w455q_181"
}, Kn = {
  TERTIARY_PURPLE: "tertiary-purple"
}, Jn = Xn.bind(Zn), J = "purpur-button", Qn = ({
  children: e,
  className: t,
  ["data-testid"]: n,
  disabled: o = !1,
  fullWidth: i = !1,
  iconOnly: r,
  loading: s = !1,
  negative: a = !1,
  onClick: c,
  size: l = "md",
  variant: u,
  type: d = "button",
  ...h
}, p) => {
  if (r && u === "destructive")
    return null;
  const m = Jn(
    [
      J,
      `${J}--${a ? `${u}-negative` : u}`,
      `${J}--${l}`
    ],
    {
      [`${J}--icon-only`]: r,
      [`${J}--negative`]: a,
      [`${J}--full-width`]: i,
      [`${J}--disabled`]: o || s
    },
    t
  ), g = (y) => {
    o || s ? y.preventDefault() : c && c(y);
  }, v = !!h["aria-disabled"] || o || s;
  return /* @__PURE__ */ Ae(
    "button",
    {
      className: m,
      "data-testid": n,
      type: d,
      ref: p,
      "aria-disabled": v,
      onClick: g,
      ...h,
      children: [
        s && /* @__PURE__ */ x(Vn, { size: l === In.LG ? "xs" : "xxs", negative: a, disabled: v }),
        " ",
        e
      ]
    }
  );
}, Lt = Nt(Qn);
Lt.displayName = "Button";
function er(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var dt = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ht;
function tr() {
  return ht || (ht = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var r = "", s = 0; s < arguments.length; s++) {
          var a = arguments[s];
          a && (r = i(r, o.call(this, a)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var s = "";
        for (var a in r)
          t.call(r, a) && r[a] && (s = i(s, this && this[a] || a));
        return s;
      }
      function i(r, s) {
        return s ? r ? r + " " + s : r + s : r;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(dt)), dt.exports;
}
var nr = tr();
const rr = /* @__PURE__ */ er(nr), or = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, ir = rr.bind(or), mt = "purpur-icon", sr = "md", ar = (e) => e.filter((t) => Object.keys(t).length >= 1).map((t) => `${t.name}="${t.value}"`).join(" "), cr = ({ content: e = "", title: t } = {}) => {
  const n = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    t ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = t ? `<title>${t}</title>` : "";
  return `<svg ${ar(n)}>${o}${e}</svg>`;
}, lr = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), Mt = ({
  ["data-testid"]: e,
  svg: t,
  allyTitle: n,
  className: o,
  size: i = sr,
  ...r
}) => {
  const s = cr({
    content: lr(t.svg),
    title: n
  }), a = ir(o, mt, `${mt}--${i}`);
  return /* @__PURE__ */ x(
    "span",
    {
      className: a,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: s },
      ...r
    }
  );
};
Mt.displayName = "Icon";
const ur = {
  name: "info",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M11 8.18c0 .537.469.979 1.007.979.524 0 .993-.442.993-.98s-.469-.979-.993-.979c-.538 0-1.007.441-1.007.98Zm.152 1.958v6.897h1.696v-6.897h-1.696Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["info"],
  category: "status"
}, $t = (e) => /* @__PURE__ */ x(Mt, { ...e, svg: ur });
$t.displayName = "IconInfo";
function fr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var gt = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var vt;
function pr() {
  return vt || (vt = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var r = "", s = 0; s < arguments.length; s++) {
          var a = arguments[s];
          a && (r = i(r, o(a)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var s = "";
        for (var a in r)
          t.call(r, a) && r[a] && (s = i(s, a));
        return s;
      }
      function i(r, s) {
        return s ? r ? r + " " + s : r + s : r;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(gt)), gt.exports;
}
var dr = pr();
const hr = /* @__PURE__ */ fr(dr), pe = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, kt = {
  PARAGRAPH100: "paragraph-100"
}, de = "purpur-paragraph", Ft = ({
  ["data-testid"]: e,
  children: t,
  className: n,
  disabled: o,
  enableHyphenation: i = !1,
  negative: r = !1,
  variant: s = kt.PARAGRAPH100,
  ...a
}) => {
  const c = hr([
    n,
    pe[de],
    pe[`${de}--${s}`],
    {
      [pe[`${de}--hyphens`]]: i,
      [pe[`${de}--disabled`]]: o,
      [pe[`${de}--negative`]]: r
    }
  ]);
  return /* @__PURE__ */ x("p", { ...a, className: c, "data-testid": e, children: t });
};
Ft.displayName = "Paragraph";
const mr = "400ms";
function q(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function yt(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function It(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((i) => {
      const r = yt(i, t);
      return !n && typeof r == "function" && (n = !0), r;
    });
    if (n)
      return () => {
        for (let i = 0; i < o.length; i++) {
          const r = o[i];
          typeof r == "function" ? r() : yt(e[i], null);
        }
      };
  };
}
function te(...e) {
  return f.useCallback(It(...e), e);
}
function Bt(e, t = []) {
  let n = [];
  function o(r, s) {
    const a = f.createContext(s), c = n.length;
    n = [...n, s];
    const l = (d) => {
      var y;
      const { scope: h, children: p, ...m } = d, g = ((y = h == null ? void 0 : h[e]) == null ? void 0 : y[c]) || a, v = f.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ x(g.Provider, { value: v, children: p });
    };
    l.displayName = r + "Provider";
    function u(d, h) {
      var g;
      const p = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[c]) || a, m = f.useContext(p);
      if (m) return m;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [l, u];
  }
  const i = () => {
    const r = n.map((s) => f.createContext(s));
    return function(a) {
      const c = (a == null ? void 0 : a[e]) || r;
      return f.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: c } }),
        [a, c]
      );
    };
  };
  return i.scopeName = e, [o, gr(i, ...t)];
}
function gr(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(r) {
      const s = o.reduce((a, { useScope: c, scopeName: l }) => {
        const d = c(r)[`__scope${l}`];
        return { ...a, ...d };
      }, {});
      return f.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Wt = f.forwardRef((e, t) => {
  const { children: n, ...o } = e, i = f.Children.toArray(n), r = i.find(vr);
  if (r) {
    const s = r.props.children, a = i.map((c) => c === r ? f.Children.count(s) > 1 ? f.Children.only(null) : f.isValidElement(s) ? s.props.children : null : c);
    return /* @__PURE__ */ x(Fe, { ...o, ref: t, children: f.isValidElement(s) ? f.cloneElement(s, void 0, a) : null });
  }
  return /* @__PURE__ */ x(Fe, { ...o, ref: t, children: n });
});
Wt.displayName = "Slot";
var Fe = f.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  if (f.isValidElement(n)) {
    const i = wr(n), r = yr(o, n.props);
    return n.type !== f.Fragment && (r.ref = t ? It(t, i) : i), f.cloneElement(n, r);
  }
  return f.Children.count(n) > 1 ? f.Children.only(null) : null;
});
Fe.displayName = "SlotClone";
var Ht = ({ children: e }) => /* @__PURE__ */ x(Dn, { children: e });
function vr(e) {
  return f.isValidElement(e) && e.type === Ht;
}
function yr(e, t) {
  const n = { ...t };
  for (const o in t) {
    const i = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? i && r ? n[o] = (...a) => {
      r(...a), i(...a);
    } : i && (n[o] = i) : o === "style" ? n[o] = { ...i, ...r } : o === "className" && (n[o] = [i, r].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function wr(e) {
  var o, i;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var xr = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], K = xr.reduce((e, t) => {
  const n = f.forwardRef((o, i) => {
    const { asChild: r, ...s } = o, a = r ? Wt : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ x(a, { ...s, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function br(e, t) {
  e && Dt.flushSync(() => e.dispatchEvent(t));
}
function se(e) {
  const t = f.useRef(e);
  return f.useEffect(() => {
    t.current = e;
  }), f.useMemo(() => (...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, []);
}
function _r(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = se(e);
  f.useEffect(() => {
    const o = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [n, t]);
}
var Ar = "DismissableLayer", Ie = "dismissableLayer.update", Pr = "dismissableLayer.pointerDownOutside", Cr = "dismissableLayer.focusOutside", wt, jt = f.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), zt = f.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: i,
      onFocusOutside: r,
      onInteractOutside: s,
      onDismiss: a,
      ...c
    } = e, l = f.useContext(jt), [u, d] = f.useState(null), h = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = f.useState({}), m = te(t, (P) => d(P)), g = Array.from(l.layers), [v] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), y = g.indexOf(v), w = u ? g.indexOf(u) : -1, A = l.layersWithOutsidePointerEventsDisabled.size > 0, b = w >= y, _ = Rr((P) => {
      const O = P.target, D = [...l.branches].some((R) => R.contains(O));
      !b || D || (i == null || i(P), s == null || s(P), P.defaultPrevented || a == null || a());
    }, h), C = Tr((P) => {
      const O = P.target;
      [...l.branches].some((R) => R.contains(O)) || (r == null || r(P), s == null || s(P), P.defaultPrevented || a == null || a());
    }, h);
    return _r((P) => {
      w === l.layers.size - 1 && (o == null || o(P), !P.defaultPrevented && a && (P.preventDefault(), a()));
    }, h), f.useEffect(() => {
      if (u)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (wt = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(u)), l.layers.add(u), xt(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = wt);
        };
    }, [u, h, n, l]), f.useEffect(() => () => {
      u && (l.layers.delete(u), l.layersWithOutsidePointerEventsDisabled.delete(u), xt());
    }, [u, l]), f.useEffect(() => {
      const P = () => p({});
      return document.addEventListener(Ie, P), () => document.removeEventListener(Ie, P);
    }, []), /* @__PURE__ */ x(
      K.div,
      {
        ...c,
        ref: m,
        style: {
          pointerEvents: A ? b ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: q(e.onFocusCapture, C.onFocusCapture),
        onBlurCapture: q(e.onBlurCapture, C.onBlurCapture),
        onPointerDownCapture: q(
          e.onPointerDownCapture,
          _.onPointerDownCapture
        )
      }
    );
  }
);
zt.displayName = Ar;
var Er = "DismissableLayerBranch", Or = f.forwardRef((e, t) => {
  const n = f.useContext(jt), o = f.useRef(null), i = te(t, o);
  return f.useEffect(() => {
    const r = o.current;
    if (r)
      return n.branches.add(r), () => {
        n.branches.delete(r);
      };
  }, [n.branches]), /* @__PURE__ */ x(K.div, { ...e, ref: i });
});
Or.displayName = Er;
function Rr(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = se(e), o = f.useRef(!1), i = f.useRef(() => {
  });
  return f.useEffect(() => {
    const r = (a) => {
      if (a.target && !o.current) {
        let c = function() {
          qt(
            Pr,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = c, t.addEventListener("click", i.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", i.current);
      o.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", r);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", r), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function Tr(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = se(e), o = f.useRef(!1);
  return f.useEffect(() => {
    const i = (r) => {
      r.target && !o.current && qt(Cr, n, { originalEvent: r }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function xt() {
  const e = new CustomEvent(Ie);
  document.dispatchEvent(e);
}
function qt(e, t, n, { discrete: o }) {
  const i = n.originalEvent.target, r = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), o ? br(i, r) : i.dispatchEvent(r);
}
var Q = globalThis != null && globalThis.document ? f.useLayoutEffect : () => {
}, Sr = f.useId || (() => {
}), Nr = 0;
function Dr(e) {
  const [t, n] = f.useState(Sr());
  return Q(() => {
    n((o) => o ?? String(Nr++));
  }, [e]), t ? `radix-${t}` : "";
}
const Lr = ["top", "right", "bottom", "left"], j = Math.min, I = Math.max, Pe = Math.round, xe = Math.floor, G = (e) => ({
  x: e,
  y: e
}), Mr = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, $r = {
  start: "end",
  end: "start"
};
function Be(e, t, n) {
  return I(e, j(t, n));
}
function V(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function U(e) {
  return e.split("-")[0];
}
function ae(e) {
  return e.split("-")[1];
}
function qe(e) {
  return e === "x" ? "y" : "x";
}
function Ve(e) {
  return e === "y" ? "height" : "width";
}
function X(e) {
  return ["top", "bottom"].includes(U(e)) ? "y" : "x";
}
function Ue(e) {
  return qe(X(e));
}
function kr(e, t, n) {
  n === void 0 && (n = !1);
  const o = ae(e), i = Ue(e), r = Ve(i);
  let s = i === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[r] > t.floating[r] && (s = Ce(s)), [s, Ce(s)];
}
function Fr(e) {
  const t = Ce(e);
  return [We(e), t, We(t)];
}
function We(e) {
  return e.replace(/start|end/g, (t) => $r[t]);
}
function Ir(e, t, n) {
  const o = ["left", "right"], i = ["right", "left"], r = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : o : t ? o : i;
    case "left":
    case "right":
      return t ? r : s;
    default:
      return [];
  }
}
function Br(e, t, n, o) {
  const i = ae(e);
  let r = Ir(U(e), n === "start", o);
  return i && (r = r.map((s) => s + "-" + i), t && (r = r.concat(r.map(We)))), r;
}
function Ce(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Mr[t]);
}
function Wr(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Vt(e) {
  return typeof e != "number" ? Wr(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ee(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: i
  } = e;
  return {
    width: o,
    height: i,
    top: n,
    left: t,
    right: t + o,
    bottom: n + i,
    x: t,
    y: n
  };
}
function bt(e, t, n) {
  let {
    reference: o,
    floating: i
  } = e;
  const r = X(t), s = Ue(t), a = Ve(s), c = U(t), l = r === "y", u = o.x + o.width / 2 - i.width / 2, d = o.y + o.height / 2 - i.height / 2, h = o[a] / 2 - i[a] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: u,
        y: o.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      p = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: o.x - i.width,
        y: d
      };
      break;
    default:
      p = {
        x: o.x,
        y: o.y
      };
  }
  switch (ae(t)) {
    case "start":
      p[s] -= h * (n && l ? -1 : 1);
      break;
    case "end":
      p[s] += h * (n && l ? -1 : 1);
      break;
  }
  return p;
}
const Hr = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: r = [],
    platform: s
  } = n, a = r.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let l = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: u,
    y: d
  } = bt(l, o, c), h = o, p = {}, m = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: v,
      fn: y
    } = a[g], {
      x: w,
      y: A,
      data: b,
      reset: _
    } = await y({
      x: u,
      y: d,
      initialPlacement: o,
      placement: h,
      strategy: i,
      middlewareData: p,
      rects: l,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = w ?? u, d = A ?? d, p = {
      ...p,
      [v]: {
        ...p[v],
        ...b
      }
    }, _ && m <= 50 && (m++, typeof _ == "object" && (_.placement && (h = _.placement), _.rects && (l = _.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : _.rects), {
      x: u,
      y: d
    } = bt(l, h, c)), g = -1);
  }
  return {
    x: u,
    y: d,
    placement: h,
    strategy: i,
    middlewareData: p
  };
};
async function he(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: i,
    platform: r,
    rects: s,
    elements: a,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: h = !1,
    padding: p = 0
  } = V(t, e), m = Vt(p), v = a[h ? d === "floating" ? "reference" : "floating" : d], y = Ee(await r.getClippingRect({
    element: (n = await (r.isElement == null ? void 0 : r.isElement(v))) == null || n ? v : v.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(a.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: c
  })), w = d === "floating" ? {
    x: o,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, A = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(a.floating)), b = await (r.isElement == null ? void 0 : r.isElement(A)) ? await (r.getScale == null ? void 0 : r.getScale(A)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, _ = Ee(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: w,
    offsetParent: A,
    strategy: c
  }) : w);
  return {
    top: (y.top - _.top + m.top) / b.y,
    bottom: (_.bottom - y.bottom + m.bottom) / b.y,
    left: (y.left - _.left + m.left) / b.x,
    right: (_.right - y.right + m.right) / b.x
  };
}
const jr = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: i,
      rects: r,
      platform: s,
      elements: a,
      middlewareData: c
    } = t, {
      element: l,
      padding: u = 0
    } = V(e, t) || {};
    if (l == null)
      return {};
    const d = Vt(u), h = {
      x: n,
      y: o
    }, p = Ue(i), m = Ve(p), g = await s.getDimensions(l), v = p === "y", y = v ? "top" : "left", w = v ? "bottom" : "right", A = v ? "clientHeight" : "clientWidth", b = r.reference[m] + r.reference[p] - h[p] - r.floating[m], _ = h[p] - r.reference[p], C = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let P = C ? C[A] : 0;
    (!P || !await (s.isElement == null ? void 0 : s.isElement(C))) && (P = a.floating[A] || r.floating[m]);
    const O = b / 2 - _ / 2, D = P / 2 - g[m] / 2 - 1, R = j(d[y], D), M = j(d[w], D), $ = R, k = P - g[m] - M, T = P / 2 - g[m] / 2 + O, L = Be($, T, k), F = !c.arrow && ae(i) != null && T !== L && r.reference[m] / 2 - (T < $ ? R : M) - g[m] / 2 < 0, E = F ? T < $ ? T - $ : T - k : 0;
    return {
      [p]: h[p] + E,
      data: {
        [p]: L,
        centerOffset: T - L - E,
        ...F && {
          alignmentOffset: E
        }
      },
      reset: F
    };
  }
}), zr = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: i,
        middlewareData: r,
        rects: s,
        initialPlacement: a,
        platform: c,
        elements: l
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: h,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: g = !0,
        ...v
      } = V(e, t);
      if ((n = r.arrow) != null && n.alignmentOffset)
        return {};
      const y = U(i), w = X(a), A = U(a) === a, b = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), _ = h || (A || !g ? [Ce(a)] : Fr(a)), C = m !== "none";
      !h && C && _.push(...Br(a, g, m, b));
      const P = [a, ..._], O = await he(t, v), D = [];
      let R = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (u && D.push(O[y]), d) {
        const T = kr(i, s, b);
        D.push(O[T[0]], O[T[1]]);
      }
      if (R = [...R, {
        placement: i,
        overflows: D
      }], !D.every((T) => T <= 0)) {
        var M, $;
        const T = (((M = r.flip) == null ? void 0 : M.index) || 0) + 1, L = P[T];
        if (L)
          return {
            data: {
              index: T,
              overflows: R
            },
            reset: {
              placement: L
            }
          };
        let F = ($ = R.filter((E) => E.overflows[0] <= 0).sort((E, S) => E.overflows[1] - S.overflows[1])[0]) == null ? void 0 : $.placement;
        if (!F)
          switch (p) {
            case "bestFit": {
              var k;
              const E = (k = R.filter((S) => {
                if (C) {
                  const N = X(S.placement);
                  return N === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  N === "y";
                }
                return !0;
              }).map((S) => [S.placement, S.overflows.filter((N) => N > 0).reduce((N, Le) => N + Le, 0)]).sort((S, N) => S[1] - N[1])[0]) == null ? void 0 : k[0];
              E && (F = E);
              break;
            }
            case "initialPlacement":
              F = a;
              break;
          }
        if (i !== F)
          return {
            reset: {
              placement: F
            }
          };
      }
      return {};
    }
  };
};
function _t(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function At(e) {
  return Lr.some((t) => e[t] >= 0);
}
const qr = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: o = "referenceHidden",
        ...i
      } = V(e, t);
      switch (o) {
        case "referenceHidden": {
          const r = await he(t, {
            ...i,
            elementContext: "reference"
          }), s = _t(r, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: At(s)
            }
          };
        }
        case "escaped": {
          const r = await he(t, {
            ...i,
            altBoundary: !0
          }), s = _t(r, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: At(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Vr(e, t) {
  const {
    placement: n,
    platform: o,
    elements: i
  } = e, r = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), s = U(n), a = ae(n), c = X(n) === "y", l = ["left", "top"].includes(s) ? -1 : 1, u = r && c ? -1 : 1, d = V(t, e);
  let {
    mainAxis: h,
    crossAxis: p,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return a && typeof m == "number" && (p = a === "end" ? m * -1 : m), c ? {
    x: p * u,
    y: h * l
  } : {
    x: h * l,
    y: p * u
  };
}
const Ur = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: i,
        y: r,
        placement: s,
        middlewareData: a
      } = t, c = await Vr(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (o = a.arrow) != null && o.alignmentOffset ? {} : {
        x: i + c.x,
        y: r + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, Yr = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: i
      } = t, {
        mainAxis: r = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (v) => {
            let {
              x: y,
              y: w
            } = v;
            return {
              x: y,
              y: w
            };
          }
        },
        ...c
      } = V(e, t), l = {
        x: n,
        y: o
      }, u = await he(t, c), d = X(U(i)), h = qe(d);
      let p = l[h], m = l[d];
      if (r) {
        const v = h === "y" ? "top" : "left", y = h === "y" ? "bottom" : "right", w = p + u[v], A = p - u[y];
        p = Be(w, p, A);
      }
      if (s) {
        const v = d === "y" ? "top" : "left", y = d === "y" ? "bottom" : "right", w = m + u[v], A = m - u[y];
        m = Be(w, m, A);
      }
      const g = a.fn({
        ...t,
        [h]: p,
        [d]: m
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - o
        }
      };
    }
  };
}, Gr = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: o,
        placement: i,
        rects: r,
        middlewareData: s
      } = t, {
        offset: a = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = V(e, t), u = {
        x: n,
        y: o
      }, d = X(i), h = qe(d);
      let p = u[h], m = u[d];
      const g = V(a, t), v = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (c) {
        const A = h === "y" ? "height" : "width", b = r.reference[h] - r.floating[A] + v.mainAxis, _ = r.reference[h] + r.reference[A] - v.mainAxis;
        p < b ? p = b : p > _ && (p = _);
      }
      if (l) {
        var y, w;
        const A = h === "y" ? "width" : "height", b = ["top", "left"].includes(U(i)), _ = r.reference[d] - r.floating[A] + (b && ((y = s.offset) == null ? void 0 : y[d]) || 0) + (b ? 0 : v.crossAxis), C = r.reference[d] + r.reference[A] + (b ? 0 : ((w = s.offset) == null ? void 0 : w[d]) || 0) - (b ? v.crossAxis : 0);
        m < _ ? m = _ : m > C && (m = C);
      }
      return {
        [h]: p,
        [d]: m
      };
    }
  };
}, Xr = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: o,
        platform: i,
        elements: r
      } = t, {
        apply: s = () => {
        },
        ...a
      } = V(e, t), c = await he(t, a), l = U(n), u = ae(n), d = X(n) === "y", {
        width: h,
        height: p
      } = o.floating;
      let m, g;
      l === "top" || l === "bottom" ? (m = l, g = u === (await (i.isRTL == null ? void 0 : i.isRTL(r.floating)) ? "start" : "end") ? "left" : "right") : (g = l, m = u === "end" ? "top" : "bottom");
      const v = p - c.top - c.bottom, y = h - c.left - c.right, w = j(p - c[m], v), A = j(h - c[g], y), b = !t.middlewareData.shift;
      let _ = w, C = A;
      if (d ? C = u || b ? j(A, y) : y : _ = u || b ? j(w, v) : v, b && !u) {
        const O = I(c.left, 0), D = I(c.right, 0), R = I(c.top, 0), M = I(c.bottom, 0);
        d ? C = h - 2 * (O !== 0 || D !== 0 ? O + D : I(c.left, c.right)) : _ = p - 2 * (R !== 0 || M !== 0 ? R + M : I(c.top, c.bottom));
      }
      await s({
        ...t,
        availableWidth: C,
        availableHeight: _
      });
      const P = await i.getDimensions(r.floating);
      return h !== P.width || p !== P.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ce(e) {
  return Ut(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function B(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Y(e) {
  var t;
  return (t = (Ut(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ut(e) {
  return e instanceof Node || e instanceof B(e).Node;
}
function W(e) {
  return e instanceof Element || e instanceof B(e).Element;
}
function z(e) {
  return e instanceof HTMLElement || e instanceof B(e).HTMLElement;
}
function Pt(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof B(e).ShadowRoot;
}
function ge(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: i
  } = H(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(i);
}
function Zr(e) {
  return ["table", "td", "th"].includes(ce(e));
}
function Re(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Ye(e) {
  const t = Ge(), n = W(e) ? H(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function Kr(e) {
  let t = Z(e);
  for (; z(t) && !oe(t); ) {
    if (Ye(t))
      return t;
    if (Re(t))
      return null;
    t = Z(t);
  }
  return null;
}
function Ge() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function oe(e) {
  return ["html", "body", "#document"].includes(ce(e));
}
function H(e) {
  return B(e).getComputedStyle(e);
}
function Te(e) {
  return W(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Z(e) {
  if (ce(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Pt(e) && e.host || // Fallback.
    Y(e)
  );
  return Pt(t) ? t.host : t;
}
function Yt(e) {
  const t = Z(e);
  return oe(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : z(t) && ge(t) ? t : Yt(t);
}
function me(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = Yt(e), r = i === ((o = e.ownerDocument) == null ? void 0 : o.body), s = B(i);
  if (r) {
    const a = He(s);
    return t.concat(s, s.visualViewport || [], ge(i) ? i : [], a && n ? me(a) : []);
  }
  return t.concat(i, me(i, [], n));
}
function He(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Gt(e) {
  const t = H(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const i = z(e), r = i ? e.offsetWidth : n, s = i ? e.offsetHeight : o, a = Pe(n) !== r || Pe(o) !== s;
  return a && (n = r, o = s), {
    width: n,
    height: o,
    $: a
  };
}
function Xe(e) {
  return W(e) ? e : e.contextElement;
}
function re(e) {
  const t = Xe(e);
  if (!z(t))
    return G(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: i,
    $: r
  } = Gt(t);
  let s = (r ? Pe(n.width) : n.width) / o, a = (r ? Pe(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const Jr = /* @__PURE__ */ G(0);
function Xt(e) {
  const t = B(e);
  return !Ge() || !t.visualViewport ? Jr : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Qr(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== B(e) ? !1 : t;
}
function ee(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), r = Xe(e);
  let s = G(1);
  t && (o ? W(o) && (s = re(o)) : s = re(e));
  const a = Qr(r, n, o) ? Xt(r) : G(0);
  let c = (i.left + a.x) / s.x, l = (i.top + a.y) / s.y, u = i.width / s.x, d = i.height / s.y;
  if (r) {
    const h = B(r), p = o && W(o) ? B(o) : o;
    let m = h, g = He(m);
    for (; g && o && p !== m; ) {
      const v = re(g), y = g.getBoundingClientRect(), w = H(g), A = y.left + (g.clientLeft + parseFloat(w.paddingLeft)) * v.x, b = y.top + (g.clientTop + parseFloat(w.paddingTop)) * v.y;
      c *= v.x, l *= v.y, u *= v.x, d *= v.y, c += A, l += b, m = B(g), g = He(m);
    }
  }
  return Ee({
    width: u,
    height: d,
    x: c,
    y: l
  });
}
function eo(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: i
  } = e;
  const r = i === "fixed", s = Y(o), a = t ? Re(t.floating) : !1;
  if (o === s || a && r)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = G(1);
  const u = G(0), d = z(o);
  if ((d || !d && !r) && ((ce(o) !== "body" || ge(s)) && (c = Te(o)), z(o))) {
    const h = ee(o);
    l = re(o), u.x = h.x + o.clientLeft, u.y = h.y + o.clientTop;
  }
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - c.scrollLeft * l.x + u.x,
    y: n.y * l.y - c.scrollTop * l.y + u.y
  };
}
function to(e) {
  return Array.from(e.getClientRects());
}
function Zt(e) {
  return ee(Y(e)).left + Te(e).scrollLeft;
}
function no(e) {
  const t = Y(e), n = Te(e), o = e.ownerDocument.body, i = I(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), r = I(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + Zt(e);
  const a = -n.scrollTop;
  return H(o).direction === "rtl" && (s += I(t.clientWidth, o.clientWidth) - i), {
    width: i,
    height: r,
    x: s,
    y: a
  };
}
function ro(e, t) {
  const n = B(e), o = Y(e), i = n.visualViewport;
  let r = o.clientWidth, s = o.clientHeight, a = 0, c = 0;
  if (i) {
    r = i.width, s = i.height;
    const l = Ge();
    (!l || l && t === "fixed") && (a = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: r,
    height: s,
    x: a,
    y: c
  };
}
function oo(e, t) {
  const n = ee(e, !0, t === "fixed"), o = n.top + e.clientTop, i = n.left + e.clientLeft, r = z(e) ? re(e) : G(1), s = e.clientWidth * r.x, a = e.clientHeight * r.y, c = i * r.x, l = o * r.y;
  return {
    width: s,
    height: a,
    x: c,
    y: l
  };
}
function Ct(e, t, n) {
  let o;
  if (t === "viewport")
    o = ro(e, n);
  else if (t === "document")
    o = no(Y(e));
  else if (W(t))
    o = oo(t, n);
  else {
    const i = Xt(e);
    o = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return Ee(o);
}
function Kt(e, t) {
  const n = Z(e);
  return n === t || !W(n) || oe(n) ? !1 : H(n).position === "fixed" || Kt(n, t);
}
function io(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = me(e, [], !1).filter((a) => W(a) && ce(a) !== "body"), i = null;
  const r = H(e).position === "fixed";
  let s = r ? Z(e) : e;
  for (; W(s) && !oe(s); ) {
    const a = H(s), c = Ye(s);
    !c && a.position === "fixed" && (i = null), (r ? !c && !i : !c && a.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || ge(s) && !c && Kt(e, s)) ? o = o.filter((u) => u !== s) : i = a, s = Z(s);
  }
  return t.set(e, o), o;
}
function so(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: i
  } = e;
  const s = [...n === "clippingAncestors" ? Re(t) ? [] : io(t, this._c) : [].concat(n), o], a = s[0], c = s.reduce((l, u) => {
    const d = Ct(t, u, i);
    return l.top = I(d.top, l.top), l.right = j(d.right, l.right), l.bottom = j(d.bottom, l.bottom), l.left = I(d.left, l.left), l;
  }, Ct(t, a, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function ao(e) {
  const {
    width: t,
    height: n
  } = Gt(e);
  return {
    width: t,
    height: n
  };
}
function co(e, t, n) {
  const o = z(t), i = Y(t), r = n === "fixed", s = ee(e, !0, r, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = G(0);
  if (o || !o && !r)
    if ((ce(t) !== "body" || ge(i)) && (a = Te(t)), o) {
      const d = ee(t, !0, r, t);
      c.x = d.x + t.clientLeft, c.y = d.y + t.clientTop;
    } else i && (c.x = Zt(i));
  const l = s.left + a.scrollLeft - c.x, u = s.top + a.scrollTop - c.y;
  return {
    x: l,
    y: u,
    width: s.width,
    height: s.height
  };
}
function Me(e) {
  return H(e).position === "static";
}
function Et(e, t) {
  return !z(e) || H(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Jt(e, t) {
  const n = B(e);
  if (Re(e))
    return n;
  if (!z(e)) {
    let i = Z(e);
    for (; i && !oe(i); ) {
      if (W(i) && !Me(i))
        return i;
      i = Z(i);
    }
    return n;
  }
  let o = Et(e, t);
  for (; o && Zr(o) && Me(o); )
    o = Et(o, t);
  return o && oe(o) && Me(o) && !Ye(o) ? n : o || Kr(e) || n;
}
const lo = async function(e) {
  const t = this.getOffsetParent || Jt, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: co(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function uo(e) {
  return H(e).direction === "rtl";
}
const fo = {
  convertOffsetParentRelativeRectToViewportRelativeRect: eo,
  getDocumentElement: Y,
  getClippingRect: so,
  getOffsetParent: Jt,
  getElementRects: lo,
  getClientRects: to,
  getDimensions: ao,
  getScale: re,
  isElement: W,
  isRTL: uo
};
function po(e, t) {
  let n = null, o;
  const i = Y(e);
  function r() {
    var a;
    clearTimeout(o), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), r();
    const {
      left: l,
      top: u,
      width: d,
      height: h
    } = e.getBoundingClientRect();
    if (a || t(), !d || !h)
      return;
    const p = xe(u), m = xe(i.clientWidth - (l + d)), g = xe(i.clientHeight - (u + h)), v = xe(l), w = {
      rootMargin: -p + "px " + -m + "px " + -g + "px " + -v + "px",
      threshold: I(0, j(1, c)) || 1
    };
    let A = !0;
    function b(_) {
      const C = _[0].intersectionRatio;
      if (C !== c) {
        if (!A)
          return s();
        C ? s(!1, C) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      A = !1;
    }
    try {
      n = new IntersectionObserver(b, {
        ...w,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(b, w);
    }
    n.observe(e);
  }
  return s(!0), r;
}
function ho(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: r = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = o, l = Xe(e), u = i || r ? [...l ? me(l) : [], ...me(t)] : [];
  u.forEach((y) => {
    i && y.addEventListener("scroll", n, {
      passive: !0
    }), r && y.addEventListener("resize", n);
  });
  const d = l && a ? po(l, n) : null;
  let h = -1, p = null;
  s && (p = new ResizeObserver((y) => {
    let [w] = y;
    w && w.target === l && p && (p.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var A;
      (A = p) == null || A.observe(t);
    })), n();
  }), l && !c && p.observe(l), p.observe(t));
  let m, g = c ? ee(e) : null;
  c && v();
  function v() {
    const y = ee(e);
    g && (y.x !== g.x || y.y !== g.y || y.width !== g.width || y.height !== g.height) && n(), g = y, m = requestAnimationFrame(v);
  }
  return n(), () => {
    var y;
    u.forEach((w) => {
      i && w.removeEventListener("scroll", n), r && w.removeEventListener("resize", n);
    }), d == null || d(), (y = p) == null || y.disconnect(), p = null, c && cancelAnimationFrame(m);
  };
}
const mo = Ur, go = Yr, vo = zr, yo = Xr, wo = qr, Ot = jr, xo = Gr, bo = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: fo,
    ...n
  }, r = {
    ...i.platform,
    _c: o
  };
  return Hr(e, t, {
    ...i,
    platform: r
  });
};
var _e = typeof document < "u" ? Ln : Mn;
function Oe(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0; )
        if (!Oe(e[o], t[o]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const r = i[o];
      if (!(r === "_owner" && e.$$typeof) && !Oe(e[r], t[r]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Qt(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Rt(e, t) {
  const n = Qt(e);
  return Math.round(t * n) / n;
}
function Tt(e) {
  const t = f.useRef(e);
  return _e(() => {
    t.current = e;
  }), t;
}
function _o(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: i,
    elements: {
      reference: r,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: c,
    open: l
  } = e, [u, d] = f.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, p] = f.useState(o);
  Oe(h, o) || p(o);
  const [m, g] = f.useState(null), [v, y] = f.useState(null), w = f.useCallback((E) => {
    E !== C.current && (C.current = E, g(E));
  }, []), A = f.useCallback((E) => {
    E !== P.current && (P.current = E, y(E));
  }, []), b = r || m, _ = s || v, C = f.useRef(null), P = f.useRef(null), O = f.useRef(u), D = c != null, R = Tt(c), M = Tt(i), $ = f.useCallback(() => {
    if (!C.current || !P.current)
      return;
    const E = {
      placement: t,
      strategy: n,
      middleware: h
    };
    M.current && (E.platform = M.current), bo(C.current, P.current, E).then((S) => {
      const N = {
        ...S,
        isPositioned: !0
      };
      k.current && !Oe(O.current, N) && (O.current = N, Dt.flushSync(() => {
        d(N);
      }));
    });
  }, [h, t, n, M]);
  _e(() => {
    l === !1 && O.current.isPositioned && (O.current.isPositioned = !1, d((E) => ({
      ...E,
      isPositioned: !1
    })));
  }, [l]);
  const k = f.useRef(!1);
  _e(() => (k.current = !0, () => {
    k.current = !1;
  }), []), _e(() => {
    if (b && (C.current = b), _ && (P.current = _), b && _) {
      if (R.current)
        return R.current(b, _, $);
      $();
    }
  }, [b, _, $, R, D]);
  const T = f.useMemo(() => ({
    reference: C,
    floating: P,
    setReference: w,
    setFloating: A
  }), [w, A]), L = f.useMemo(() => ({
    reference: b,
    floating: _
  }), [b, _]), F = f.useMemo(() => {
    const E = {
      position: n,
      left: 0,
      top: 0
    };
    if (!L.floating)
      return E;
    const S = Rt(L.floating, u.x), N = Rt(L.floating, u.y);
    return a ? {
      ...E,
      transform: "translate(" + S + "px, " + N + "px)",
      ...Qt(L.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: S,
      top: N
    };
  }, [n, a, L.floating, u.x, u.y]);
  return f.useMemo(() => ({
    ...u,
    update: $,
    refs: T,
    elements: L,
    floatingStyles: F
  }), [u, $, T, L, F]);
}
const Ao = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? Ot({
        element: o.current,
        padding: i
      }).fn(n) : {} : o ? Ot({
        element: o,
        padding: i
      }).fn(n) : {};
    }
  };
}, Po = (e, t) => ({
  ...mo(e),
  options: [e, t]
}), Co = (e, t) => ({
  ...go(e),
  options: [e, t]
}), Eo = (e, t) => ({
  ...xo(e),
  options: [e, t]
}), Oo = (e, t) => ({
  ...vo(e),
  options: [e, t]
}), Ro = (e, t) => ({
  ...yo(e),
  options: [e, t]
}), To = (e, t) => ({
  ...wo(e),
  options: [e, t]
}), So = (e, t) => ({
  ...Ao(e),
  options: [e, t]
});
var No = "Arrow", en = f.forwardRef((e, t) => {
  const { children: n, width: o = 10, height: i = 5, ...r } = e;
  return /* @__PURE__ */ x(
    K.svg,
    {
      ...r,
      ref: t,
      width: o,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ x("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
en.displayName = No;
var Do = en;
function Lo(e) {
  const [t, n] = f.useState(void 0);
  return Q(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const r = i[0];
        let s, a;
        if ("borderBoxSize" in r) {
          const c = r.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          s = l.inlineSize, a = l.blockSize;
        } else
          s = e.offsetWidth, a = e.offsetHeight;
        n({ width: s, height: a });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Ze = "Popper", [tn, nn] = Bt(Ze), [Mo, rn] = tn(Ze), on = (e) => {
  const { __scopePopper: t, children: n } = e, [o, i] = f.useState(null);
  return /* @__PURE__ */ x(Mo, { scope: t, anchor: o, onAnchorChange: i, children: n });
};
on.displayName = Ze;
var sn = "PopperAnchor", an = f.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: o, ...i } = e, r = rn(sn, n), s = f.useRef(null), a = te(t, s);
    return f.useEffect(() => {
      r.onAnchorChange((o == null ? void 0 : o.current) || s.current);
    }), o ? null : /* @__PURE__ */ x(K.div, { ...i, ref: a });
  }
);
an.displayName = sn;
var Ke = "PopperContent", [$o, ko] = tn(Ke), cn = f.forwardRef(
  (e, t) => {
    var tt, nt, rt, ot, it, st;
    const {
      __scopePopper: n,
      side: o = "bottom",
      sideOffset: i = 0,
      align: r = "center",
      alignOffset: s = 0,
      arrowPadding: a = 0,
      avoidCollisions: c = !0,
      collisionBoundary: l = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: m,
      ...g
    } = e, v = rn(Ke, n), [y, w] = f.useState(null), A = te(t, (le) => w(le)), [b, _] = f.useState(null), C = Lo(b), P = (C == null ? void 0 : C.width) ?? 0, O = (C == null ? void 0 : C.height) ?? 0, D = o + (r !== "center" ? "-" + r : ""), R = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, M = Array.isArray(l) ? l : [l], $ = M.length > 0, k = {
      padding: R,
      boundary: M.filter(Io),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: $
    }, { refs: T, floatingStyles: L, placement: F, isPositioned: E, middlewareData: S } = _o({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: D,
      whileElementsMounted: (...le) => ho(...le, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        Po({ mainAxis: i + O, alignmentAxis: s }),
        c && Co({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? Eo() : void 0,
          ...k
        }),
        c && Oo({ ...k }),
        Ro({
          ...k,
          apply: ({ elements: le, rects: at, availableWidth: Rn, availableHeight: Tn }) => {
            const { width: Sn, height: Nn } = at.reference, we = le.floating.style;
            we.setProperty("--radix-popper-available-width", `${Rn}px`), we.setProperty("--radix-popper-available-height", `${Tn}px`), we.setProperty("--radix-popper-anchor-width", `${Sn}px`), we.setProperty("--radix-popper-anchor-height", `${Nn}px`);
          }
        }),
        b && So({ element: b, padding: a }),
        Bo({ arrowWidth: P, arrowHeight: O }),
        h && To({ strategy: "referenceHidden", ...k })
      ]
    }), [N, Le] = fn(F), ye = se(m);
    Q(() => {
      E && (ye == null || ye());
    }, [E, ye]);
    const An = (tt = S.arrow) == null ? void 0 : tt.x, Pn = (nt = S.arrow) == null ? void 0 : nt.y, Cn = ((rt = S.arrow) == null ? void 0 : rt.centerOffset) !== 0, [En, On] = f.useState();
    return Q(() => {
      y && On(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ x(
      "div",
      {
        ref: T.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...L,
          transform: E ? L.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: En,
          "--radix-popper-transform-origin": [
            (ot = S.transformOrigin) == null ? void 0 : ot.x,
            (it = S.transformOrigin) == null ? void 0 : it.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((st = S.hide) == null ? void 0 : st.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ x(
          $o,
          {
            scope: n,
            placedSide: N,
            onArrowChange: _,
            arrowX: An,
            arrowY: Pn,
            shouldHideArrow: Cn,
            children: /* @__PURE__ */ x(
              K.div,
              {
                "data-side": N,
                "data-align": Le,
                ...g,
                ref: A,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: E ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
cn.displayName = Ke;
var ln = "PopperArrow", Fo = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, un = f.forwardRef(function(t, n) {
  const { __scopePopper: o, ...i } = t, r = ko(ln, o), s = Fo[r.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ x(
      "span",
      {
        ref: r.onArrowChange,
        style: {
          position: "absolute",
          left: r.arrowX,
          top: r.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[r.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[r.placedSide],
          visibility: r.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ x(
          Do,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
un.displayName = ln;
function Io(e) {
  return e !== null;
}
var Bo = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var v, y, w;
    const { placement: n, rects: o, middlewareData: i } = t, s = ((v = i.arrow) == null ? void 0 : v.centerOffset) !== 0, a = s ? 0 : e.arrowWidth, c = s ? 0 : e.arrowHeight, [l, u] = fn(n), d = { start: "0%", center: "50%", end: "100%" }[u], h = (((y = i.arrow) == null ? void 0 : y.x) ?? 0) + a / 2, p = (((w = i.arrow) == null ? void 0 : w.y) ?? 0) + c / 2;
    let m = "", g = "";
    return l === "bottom" ? (m = s ? d : `${h}px`, g = `${-c}px`) : l === "top" ? (m = s ? d : `${h}px`, g = `${o.floating.height + c}px`) : l === "right" ? (m = `${-c}px`, g = s ? d : `${p}px`) : l === "left" && (m = `${o.floating.width + c}px`, g = s ? d : `${p}px`), { data: { x: m, y: g } };
  }
});
function fn(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Wo = on, Ho = an, jo = cn, zo = un, qo = "Portal", pn = f.forwardRef((e, t) => {
  var a;
  const { container: n, ...o } = e, [i, r] = f.useState(!1);
  Q(() => r(!0), []);
  const s = n || i && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? Fn.createPortal(/* @__PURE__ */ x(K.div, { ...o, ref: t }), s) : null;
});
pn.displayName = qo;
function Vo(e, t) {
  return f.useReducer((n, o) => t[n][o] ?? n, e);
}
var Je = (e) => {
  const { present: t, children: n } = e, o = Uo(t), i = typeof n == "function" ? n({ present: o.isPresent }) : f.Children.only(n), r = te(o.ref, Yo(i));
  return typeof n == "function" || o.isPresent ? f.cloneElement(i, { ref: r }) : null;
};
Je.displayName = "Presence";
function Uo(e) {
  const [t, n] = f.useState(), o = f.useRef({}), i = f.useRef(e), r = f.useRef("none"), s = e ? "mounted" : "unmounted", [a, c] = Vo(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return f.useEffect(() => {
    const l = be(o.current);
    r.current = a === "mounted" ? l : "none";
  }, [a]), Q(() => {
    const l = o.current, u = i.current;
    if (u !== e) {
      const h = r.current, p = be(l);
      e ? c("MOUNT") : p === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(u && h !== p ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, c]), Q(() => {
    if (t) {
      let l;
      const u = t.ownerDocument.defaultView ?? window, d = (p) => {
        const g = be(o.current).includes(p.animationName);
        if (p.target === t && g && (c("ANIMATION_END"), !i.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, h = (p) => {
        p.target === t && (r.current = be(o.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(l), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: f.useCallback((l) => {
      l && (o.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function be(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Yo(e) {
  var o, i;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Go({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [o, i] = Xo({ defaultProp: t, onChange: n }), r = e !== void 0, s = r ? e : o, a = se(n), c = f.useCallback(
    (l) => {
      if (r) {
        const d = typeof l == "function" ? l(e) : l;
        d !== e && a(d);
      } else
        i(l);
    },
    [r, e, i, a]
  );
  return [s, c];
}
function Xo({
  defaultProp: e,
  onChange: t
}) {
  const n = f.useState(e), [o] = n, i = f.useRef(o), r = se(t);
  return f.useEffect(() => {
    i.current !== o && (r(o), i.current = o);
  }, [o, i, r]), n;
}
var Zo = "VisuallyHidden", dn = f.forwardRef(
  (e, t) => /* @__PURE__ */ x(
    K.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
dn.displayName = Zo;
var Ko = dn, [Se, Li] = Bt("Tooltip", [
  nn
]), Ne = nn(), hn = "TooltipProvider", Jo = 700, je = "tooltip.open", [Qo, Qe] = Se(hn), mn = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = Jo,
    skipDelayDuration: o = 300,
    disableHoverableContent: i = !1,
    children: r
  } = e, [s, a] = f.useState(!0), c = f.useRef(!1), l = f.useRef(0);
  return f.useEffect(() => {
    const u = l.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ x(
    Qo,
    {
      scope: t,
      isOpenDelayed: s,
      delayDuration: n,
      onOpen: f.useCallback(() => {
        window.clearTimeout(l.current), a(!1);
      }, []),
      onClose: f.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => a(!0),
          o
        );
      }, [o]),
      isPointerInTransitRef: c,
      onPointerInTransitChange: f.useCallback((u) => {
        c.current = u;
      }, []),
      disableHoverableContent: i,
      children: r
    }
  );
};
mn.displayName = hn;
var De = "Tooltip", [ei, ve] = Se(De), gn = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: o,
    defaultOpen: i = !1,
    onOpenChange: r,
    disableHoverableContent: s,
    delayDuration: a
  } = e, c = Qe(De, e.__scopeTooltip), l = Ne(t), [u, d] = f.useState(null), h = Dr(), p = f.useRef(0), m = s ?? c.disableHoverableContent, g = a ?? c.delayDuration, v = f.useRef(!1), [y = !1, w] = Go({
    prop: o,
    defaultProp: i,
    onChange: (P) => {
      P ? (c.onOpen(), document.dispatchEvent(new CustomEvent(je))) : c.onClose(), r == null || r(P);
    }
  }), A = f.useMemo(() => y ? v.current ? "delayed-open" : "instant-open" : "closed", [y]), b = f.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, v.current = !1, w(!0);
  }, [w]), _ = f.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, w(!1);
  }, [w]), C = f.useCallback(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      v.current = !0, w(!0), p.current = 0;
    }, g);
  }, [g, w]);
  return f.useEffect(() => () => {
    p.current && (window.clearTimeout(p.current), p.current = 0);
  }, []), /* @__PURE__ */ x(Wo, { ...l, children: /* @__PURE__ */ x(
    ei,
    {
      scope: t,
      contentId: h,
      open: y,
      stateAttribute: A,
      trigger: u,
      onTriggerChange: d,
      onTriggerEnter: f.useCallback(() => {
        c.isOpenDelayed ? C() : b();
      }, [c.isOpenDelayed, C, b]),
      onTriggerLeave: f.useCallback(() => {
        m ? _() : (window.clearTimeout(p.current), p.current = 0);
      }, [_, m]),
      onOpen: b,
      onClose: _,
      disableHoverableContent: m,
      children: n
    }
  ) });
};
gn.displayName = De;
var ze = "TooltipTrigger", vn = f.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...o } = e, i = ve(ze, n), r = Qe(ze, n), s = Ne(n), a = f.useRef(null), c = te(t, a, i.onTriggerChange), l = f.useRef(!1), u = f.useRef(!1), d = f.useCallback(() => l.current = !1, []);
    return f.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ x(Ho, { asChild: !0, ...s, children: /* @__PURE__ */ x(
      K.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...o,
        ref: c,
        onPointerMove: q(e.onPointerMove, (h) => {
          h.pointerType !== "touch" && !u.current && !r.isPointerInTransitRef.current && (i.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: q(e.onPointerLeave, () => {
          i.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: q(e.onPointerDown, () => {
          l.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: q(e.onFocus, () => {
          l.current || i.onOpen();
        }),
        onBlur: q(e.onBlur, i.onClose),
        onClick: q(e.onClick, i.onClose)
      }
    ) });
  }
);
vn.displayName = ze;
var et = "TooltipPortal", [ti, ni] = Se(et, {
  forceMount: void 0
}), yn = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: o, container: i } = e, r = ve(et, t);
  return /* @__PURE__ */ x(ti, { scope: t, forceMount: n, children: /* @__PURE__ */ x(Je, { present: n || r.open, children: /* @__PURE__ */ x(pn, { asChild: !0, container: i, children: o }) }) });
};
yn.displayName = et;
var ie = "TooltipContent", wn = f.forwardRef(
  (e, t) => {
    const n = ni(ie, e.__scopeTooltip), { forceMount: o = n.forceMount, side: i = "top", ...r } = e, s = ve(ie, e.__scopeTooltip);
    return /* @__PURE__ */ x(Je, { present: o || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ x(xn, { side: i, ...r, ref: t }) : /* @__PURE__ */ x(ri, { side: i, ...r, ref: t }) });
  }
), ri = f.forwardRef((e, t) => {
  const n = ve(ie, e.__scopeTooltip), o = Qe(ie, e.__scopeTooltip), i = f.useRef(null), r = te(t, i), [s, a] = f.useState(null), { trigger: c, onClose: l } = n, u = i.current, { onPointerInTransitChange: d } = o, h = f.useCallback(() => {
    a(null), d(!1);
  }, [d]), p = f.useCallback(
    (m, g) => {
      const v = m.currentTarget, y = { x: m.clientX, y: m.clientY }, w = si(y, v.getBoundingClientRect()), A = ai(y, w), b = ci(g.getBoundingClientRect()), _ = ui([...A, ...b]);
      a(_), d(!0);
    },
    [d]
  );
  return f.useEffect(() => () => h(), [h]), f.useEffect(() => {
    if (c && u) {
      const m = (v) => p(v, u), g = (v) => p(v, c);
      return c.addEventListener("pointerleave", m), u.addEventListener("pointerleave", g), () => {
        c.removeEventListener("pointerleave", m), u.removeEventListener("pointerleave", g);
      };
    }
  }, [c, u, p, h]), f.useEffect(() => {
    if (s) {
      const m = (g) => {
        const v = g.target, y = { x: g.clientX, y: g.clientY }, w = (c == null ? void 0 : c.contains(v)) || (u == null ? void 0 : u.contains(v)), A = !li(y, s);
        w ? h() : A && (h(), l());
      };
      return document.addEventListener("pointermove", m), () => document.removeEventListener("pointermove", m);
    }
  }, [c, u, s, l, h]), /* @__PURE__ */ x(xn, { ...e, ref: r });
}), [oi, ii] = Se(De, { isInside: !1 }), xn = f.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: o,
      "aria-label": i,
      onEscapeKeyDown: r,
      onPointerDownOutside: s,
      ...a
    } = e, c = ve(ie, n), l = Ne(n), { onClose: u } = c;
    return f.useEffect(() => (document.addEventListener(je, u), () => document.removeEventListener(je, u)), [u]), f.useEffect(() => {
      if (c.trigger) {
        const d = (h) => {
          const p = h.target;
          p != null && p.contains(c.trigger) && u();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [c.trigger, u]), /* @__PURE__ */ x(
      zt,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: r,
        onPointerDownOutside: s,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ Ae(
          jo,
          {
            "data-state": c.stateAttribute,
            ...l,
            ...a,
            ref: t,
            style: {
              ...a.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ x(Ht, { children: o }),
              /* @__PURE__ */ x(oi, { scope: n, isInside: !0, children: /* @__PURE__ */ x(Ko, { id: c.contentId, role: "tooltip", children: i || o }) })
            ]
          }
        )
      }
    );
  }
);
wn.displayName = ie;
var bn = "TooltipArrow", _n = f.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...o } = e, i = Ne(n);
    return ii(
      bn,
      n
    ).isInside ? null : /* @__PURE__ */ x(zo, { ...i, ...o, ref: t });
  }
);
_n.displayName = bn;
function si(e, t) {
  const n = Math.abs(t.top - e.y), o = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), r = Math.abs(t.left - e.x);
  switch (Math.min(n, o, i, r)) {
    case r:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case o:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function ai(e, t, n = 5) {
  const o = [];
  switch (t) {
    case "top":
      o.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      o.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      o.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      o.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return o;
}
function ci(e) {
  const { top: t, right: n, bottom: o, left: i } = e;
  return [
    { x: i, y: t },
    { x: n, y: t },
    { x: n, y: o },
    { x: i, y: o }
  ];
}
function li(e, t) {
  const { x: n, y: o } = e;
  let i = !1;
  for (let r = 0, s = t.length - 1; r < t.length; s = r++) {
    const a = t[r].x, c = t[r].y, l = t[s].x, u = t[s].y;
    c > o != u > o && n < (l - a) * (o - c) / (u - c) + a && (i = !i);
  }
  return i;
}
function ui(e) {
  const t = e.slice();
  return t.sort((n, o) => n.x < o.x ? -1 : n.x > o.x ? 1 : n.y < o.y ? -1 : n.y > o.y ? 1 : 0), fi(t);
}
function fi(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let o = 0; o < e.length; o++) {
    const i = e[o];
    for (; t.length >= 2; ) {
      const r = t[t.length - 1], s = t[t.length - 2];
      if ((r.x - s.x) * (i.y - s.y) >= (r.y - s.y) * (i.x - s.x)) t.pop();
      else break;
    }
    t.push(i);
  }
  t.pop();
  const n = [];
  for (let o = e.length - 1; o >= 0; o--) {
    const i = e[o];
    for (; n.length >= 2; ) {
      const r = n[n.length - 1], s = n[n.length - 2];
      if ((r.x - s.x) * (i.y - s.y) >= (r.y - s.y) * (i.x - s.x)) n.pop();
      else break;
    }
    n.push(i);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var pi = mn, di = gn, hi = vn, mi = yn, gi = wn, vi = _n;
function yi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $e = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var St;
function wi() {
  return St || (St = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var r = "", s = 0; s < arguments.length; s++) {
          var a = arguments[s];
          a && (r = i(r, o.call(this, a)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var s = "";
        for (var a in r)
          t.call(r, a) && r[a] && (s = i(s, this && this[a] || a));
        return s;
      }
      function i(r, s) {
        return s ? r ? r + " " + s : r + s : r;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }($e)), $e.exports;
}
var xi = wi();
const bi = /* @__PURE__ */ yi(xi), _i = "_slideDownAndFade_fkagk_1", Ai = "_slideLeftAndFade_fkagk_1", Pi = "_slideUpAndFade_fkagk_1", Ci = "_slideRightAndFade_fkagk_1", Ei = {
  "purpur-tooltip": "_purpur-tooltip_fkagk_1",
  "purpur-tooltip__content": "_purpur-tooltip__content_fkagk_4",
  "purpur-tooltip__content--primary": "_purpur-tooltip__content--primary_fkagk_14",
  "purpur-tooltip__content--primary-negative": "_purpur-tooltip__content--primary-negative_fkagk_17",
  slideDownAndFade: _i,
  slideLeftAndFade: Ai,
  slideUpAndFade: Pi,
  slideRightAndFade: Ci,
  "purpur-tooltip__arrow--primary": "_purpur-tooltip__arrow--primary_fkagk_32",
  "purpur-tooltip__arrow--primary-negative": "_purpur-tooltip__arrow--primary-negative_fkagk_35"
}, ke = bi.bind(Ei), Oi = {
  TOP: "top",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right"
}, Ri = {
  START: "start",
  CENTER: "center",
  END: "end"
}, ne = "purpur-tooltip", Ti = Nt(
  ({
    ["data-testid"]: e,
    buttonSize: t = "md",
    children: n,
    className: o,
    contentClassName: i,
    negative: r = !1,
    position: s = Oi.TOP,
    align: a = Ri.CENTER,
    triggerAriaLabel: c,
    triggerElement: l,
    ...u
  }, d) => {
    const [h, p] = $n(!1), m = ke([
      o,
      ne,
      `${ne}--primary${r ? "-negative" : ""}`
    ]), g = /* @__PURE__ */ x(
      Lt,
      {
        ref: d,
        "aria-label": c,
        variant: Kn.TERTIARY_PURPLE,
        negative: r,
        iconOnly: !0,
        "data-testid": `${e}-trigger-button`,
        size: t,
        children: /* @__PURE__ */ x($t, { size: "md" })
      }
    );
    return /* @__PURE__ */ x("div", { "data-testid": e, className: m, children: /* @__PURE__ */ x(pi, { delayDuration: parseInt(mr), children: /* @__PURE__ */ Ae(di, { open: h, onOpenChange: p, ...u, children: [
      /* @__PURE__ */ x(
        hi,
        {
          asChild: !0,
          onClick: (v) => {
            v.preventDefault(), p(!0);
          },
          children: kn.count(l) === 0 ? g : l
        }
      ),
      /* @__PURE__ */ x(mi, { children: /* @__PURE__ */ Ae(
        gi,
        {
          side: s,
          align: a,
          className: ke([
            i,
            `${ne}__content`,
            `${ne}__content--primary${r ? "-negative" : ""}`
          ]),
          sideOffset: -5,
          "data-testid": `${e}-content`,
          children: [
            typeof n == "string" ? /* @__PURE__ */ x(
              Ft,
              {
                variant: kt.PARAGRAPH100,
                negative: !r,
                "data-testid": `${e}-paragraph`,
                children: n
              }
            ) : n,
            /* @__PURE__ */ x(
              vi,
              {
                className: ke([
                  `${ne}__arrow`,
                  `${ne}__arrow--primary${r ? "-negative" : ""}`
                ])
              }
            )
          ]
        }
      ) })
    ] }) }) });
  }
);
Ti.displayName = "Tooltip";
export {
  Ri as TOOLTIP_ALIGN,
  Oi as TOOLTIP_POSITION,
  Ti as Tooltip
};
//# sourceMappingURL=tooltip.es.js.map
